/* istanbul ignore file */
import _ from 'underscore';
import { findSiteMap } from '@bingads-webui-react/with-site-map';

const SuggestPageList = ['campaigns', 'overview', 'adgroups', 'ads', 'product-groups'];
export const getSuggestedPageResult = ({ searchEngines, scope, siteMap }) => {
  const searchResult = SuggestPageList.map((id) => {
    const siteMapItem = findSiteMap(siteMap, item => item.id === id);
    const siteMapName = siteMapItem ? siteMapItem.name : '';
    return searchEngines.map((searchEngine) => {
      const searchEngineResults = searchEngine.search(siteMapName);
      return { name: searchEngine.name, items: searchEngineResults };
    });
  });
  const items = [];
  for (let i = 0; i < searchResult.length; i += 1) {
    if (searchResult[i][0] && searchResult[i][0].items && searchResult[i][0].items.length &&
      scope.location.pathname.indexOf(searchResult[i][0].items[0].route.split('/')[0]) === -1) {
      items.push(searchResult[i][0].items[0]);
    }
  }
  const emptySearchResult = [{ name: undefined, items }];
  return emptySearchResult;
};

export const getPageSearchResult = ({ searchEngines, query }) => searchEngines
  .map((searchEngine) => {
    const searchEngineResults = searchEngine.search(query);
    return { name: searchEngine.name, items: searchEngineResults };
  });
